import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Divider from "@mui/material/Divider";
import AssetImage from "src/components/wizard/Item/AssetImage";

const styles = {
  closeButton: {
    position: "absolute",
    right: 8,
    top: 8,
  },
  itemContainer: {
    cursor: "pointer",
    "&:hover": { bgcolor: "rgba(0,0,0,0.04)" },
  },
  description: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
  },
};

export default function SelectItemToOverride({ inventoryItems, onSelect, onClose }) {
  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography fontSize={24} fontWeight={500} color="textPrimary" align="center">
          Select Item to Override
        </Typography>
        <IconButton onClick={onClose} sx={styles.closeButton}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box mt={2}>
          {inventoryItems?.map((item, index) => (
            <React.Fragment key={index}>
              {index > 0 && <Divider my={2} />}
              <Box
                display="flex"
                p={1}
                gap={2}
                sx={styles.itemContainer}
                onClick={() => onSelect(item)}
              >
                <AssetImage width={100} height={90} image={item?.asset?.images?.[0]?.url} />
                <Box>
                  <Typography variant="body1" fontWeight={500} gutterBottom>
                    {item.asset?.itemId}
                  </Typography>
                  <Typography variant="body1" gutterBottom sx={styles.description}>
                    {item.asset?.description}
                  </Typography>
                  <Typography variant="body1">Quantity: {item.quantity}</Typography>
                </Box>
              </Box>
            </React.Fragment>
          ))}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
